var _path, _path2, _g, _path3, _g2, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcima(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 24,
    viewBox: "0 0 86 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_277_106)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3496 19.0425C74.8058 19.0425 72.7432 16.9911 72.7432 14.4608C72.7432 11.9305 74.8058 9.87969 77.3496 9.87969C79.8934 9.87969 81.956 11.9305 81.956 14.4608V14.4621C81.956 16.9918 79.8927 19.0425 77.3496 19.0425ZM77.3496 5.98856C72.6448 6.04404 68.8754 9.88288 68.9314 14.5622C68.9861 19.1637 72.7233 22.8801 77.3496 22.9349C79.0304 22.9392 80.6733 22.4393 82.0621 21.5008V22.7041H85.8694V14.4614C85.8662 9.78341 82.0537 5.99111 77.3496 5.98793V5.98856ZM27.2701 22.9617C22.5608 22.9643 18.7419 19.1694 18.74 14.4869C18.7381 9.80317 22.5531 6.00514 27.2618 6.00323C30.0089 6.00132 32.5887 7.31685 34.1919 9.53662L31.0504 11.7876C30.6943 11.2948 30.2435 10.8766 29.7238 10.557C29.2042 10.2374 28.6259 10.0228 28.0223 9.92534C27.4187 9.82793 26.8016 9.84969 26.2065 9.98937C25.6114 10.1291 25.05 10.3839 24.5546 10.7393C22.4695 12.234 21.9979 15.1265 23.5008 17.199C23.947 17.8168 24.5406 18.3155 25.2285 18.6505C25.9165 18.9856 26.6775 19.1466 27.4435 19.1192C28.2096 19.0918 28.9568 18.8768 29.6187 18.4935C30.2805 18.1101 30.8363 17.5703 31.2364 16.9222L34.511 18.9348C33.753 20.1644 32.6891 21.1805 31.4212 21.8857C30.1533 22.5908 28.724 22.9613 27.2701 22.9617ZM39.9428 22.7041H36.2152V9.16549L39.9428 6.49106V22.7041ZM67.0728 13.0853V22.7041H63.0261V13.0853C63.0266 12.7207 62.9547 12.3596 62.8143 12.0226C62.674 11.6856 62.4681 11.3793 62.2084 11.1212C61.9486 10.863 61.6401 10.6582 61.3004 10.5182C60.9608 10.3783 60.5966 10.3061 60.2288 10.3057C58.6861 10.3057 57.4354 11.5504 57.4341 13.0853V22.7041H53.3354V13.0853C53.3362 12.7208 53.2646 12.3597 53.1246 12.0227C52.9847 11.6856 52.7791 11.3792 52.5196 11.1209C52.2602 10.8626 51.9519 10.6575 51.6125 10.5173C51.273 10.3771 50.909 10.3045 50.5413 10.3038C50.1735 10.3042 49.8095 10.3764 49.4698 10.5163C49.1302 10.6562 48.8217 10.861 48.562 11.119C48.3022 11.3771 48.0963 11.6833 47.956 12.0203C47.8156 12.3572 47.7436 12.7182 47.744 13.0828V22.7041H43.6974V13.0853C43.7012 9.32172 46.7732 6.27361 50.5574 6.27935C51.4604 6.28086 52.3541 6.45952 53.1871 6.80504C54.0201 7.15056 54.7759 7.6561 55.4108 8.29251C56.0477 7.65325 56.8066 7.14606 57.6433 6.80054C58.48 6.45501 59.3777 6.27805 60.2842 6.27998C64.0117 6.27998 67.0728 9.32555 67.0728 13.0853V13.0853ZM31.1907 2.41309L36.5395 5.95477V2.41309H31.1907Z",
    fill: "#6BC4E8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_277_106",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 0,
    width: 5,
    height: 3
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4775 0.521729H40.1813V2.46602H36.4775V0.521729Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_277_106)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4775 0.521729L40.1813 2.46602L36.5097 2.44816L36.4775 2.39396V0.521729Z",
    fill: "#9FE6FE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_277_106",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 5,
    width: 18,
    height: 18
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.304443 5.98792H17.4464V22.9356H0.304443V5.98792Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_277_106)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.92541 19.0425C6.38162 19.0425 4.31904 16.9911 4.31904 14.4614C4.31904 11.9304 6.38162 9.87967 8.92541 9.87967C11.4699 9.87967 13.5318 11.9304 13.5318 14.4614V14.462C13.5318 16.9924 11.4699 19.0425 8.92541 19.0425V19.0425ZM8.92541 5.9879C4.22126 5.93306 0.361814 9.68199 0.304557 14.3613C0.249229 19.0406 4.01796 22.8788 8.7234 22.9349H8.92606C10.6065 22.9387 12.2489 22.439 13.6379 21.5014V22.7041H17.4466V14.4627C17.4427 9.78401 13.6302 5.99172 8.92541 5.98854",
    fill: "#6BC4E8"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2213 3.46975L36.4771 5.95352V2.41248H39.9016C40.0564 2.41447 40.2043 2.47655 40.3136 2.5854C40.4228 2.69424 40.4846 2.84118 40.4857 2.99468C40.4774 3.08773 40.4496 3.17804 40.4041 3.25984C40.3585 3.34163 40.2963 3.41313 40.2213 3.46975Z",
    fill: "#F75200"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_277_106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85.5652,
    height: 22.9565,
    fill: "white",
    transform: "translate(0.304443 0.521729)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcima);
export default __webpack_public_path__ + "static/media/acima.728a355f4030e1389e1fdc4ce31f62d7.svg";
export { ForwardRef as ReactComponent };